import "./App.css";
import AppRoutes from "./appRoutes";


function App() {
  return (
    <div className="App">
      <AppRoutes />
    
    </div>
  );
}

export default App;
